import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { Check, Circle } from 'lucide-react';
import { authApi } from '../api';

const PASSWORD_RULES = [
  { id: 'length', label: 'At least 8 characters', test: p => p.length >= 8 },
  { id: 'upper', label: 'One uppercase letter (A-Z)', test: p => /[A-Z]/.test(p) },
  { id: 'lower', label: 'One lowercase letter (a-z)', test: p => /[a-z]/.test(p) },
  { id: 'number', label: 'One number (0-9)', test: p => /[0-9]/.test(p) },
  { id: 'special', label: 'One special character', test: p => /[!@#$%^&*(),.?":{}|<>]/.test(p) },
];

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!token) {
    return (
      <div className="auth-page">
        <div className="card" style={{ maxWidth: '400px', textAlign: 'center' }}>
          <p style={{ color: 'var(--red)', marginBottom: '16px' }}>Invalid reset link. Please request a new one.</p>
          <Link to="/forgot-password" className="btn btn--primary">Request New Link</Link>
        </div>
      </div>
    );
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      const res = await authApi.resetPassword(token, password);
      localStorage.setItem('token', res.data.token);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-page__container">
        <div className="auth-page__header">
          <h1 className="auth-page__brand">NOTCHED</h1>
        </div>

        <div className="card">
          <h2 style={{ fontSize: '28px', marginBottom: '20px' }}>NEW PASSWORD</h2>

          {error && (
            <div className="alert alert--error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form__group">
              <label>New Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
              {password && (
                <div style={{ marginTop: '8px' }}>
                  {PASSWORD_RULES.map(rule => (
                    <div key={rule.id} className={`pw-rule ${rule.test(password) ? 'pw-rule--pass' : 'pw-rule--fail'}`}>
                      <span className="pw-rule__icon">{rule.test(password) ? <Check size={12} /> : <Circle size={12} />}</span>
                      {rule.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="form__group">
              <label>Confirm Password</label>
              <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="••••••••" required />
            </div>
            <button type="submit" className="btn btn--primary btn--full" disabled={loading} style={{ marginTop: '8px' }}>
              {loading ? <span className="spinner" /> : 'SET NEW PASSWORD'}
            </button>
          </form>
        </div>

        <div className="auth-page__footer">
          <Link to="/login">Back to Login</Link>
        </div>
      </div>
    </div>
  );
}
